import { Checkbox, ListItem, ListItemIcon, ListItemText } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import clsx from "clsx"
import React from "react"

interface FilterDropdownFilterItemProps {
  onClick: () => void
  isSelected: boolean
  indeterminate?: boolean
  divider?: boolean
  label: string
  labelId: string
  className?: string
}

const useStyles = makeStyles()(
  (_theme) => ({
    listItem: {
      minHeight: 54,
      padding: 8,
      "&.MuiListItem-divider": {
        borderBottom: "1.5px solid #D8D8D8",
      },
    },
  }),
)

const FilterDropdownFilterItem = (props: FilterDropdownFilterItemProps) => {
  const { onClick, isSelected, label, labelId, divider, indeterminate, className } = props
  const { classes } = useStyles()
  return (
    <ListItem
      dense
      disableGutters
      button
      role={undefined}
      className={clsx(classes.listItem, className)}
      onClick={onClick}
      divider={divider}>
      <ListItemIcon>
        <Checkbox
          indeterminate={indeterminate}
          color="primary"
          checked={isSelected}
          tabIndex={-1}
          disableRipple
          inputProps={{ "aria-labelledby": labelId }}
        />
      </ListItemIcon>
      <ListItemText id={labelId} primary={label} />
    </ListItem>
  )
}

export default FilterDropdownFilterItem
